import React,{useMemo} from 'react';
import {LogIn,Download,Smartphone,Hash,Volume2,Mic,MicOff,Headphones,Settings,Plus,Smile,Gift,MonitorUp,Video,PhoneOff,Users,Bell,Pin,Search,MessageSquare,Bot} from 'lucide-react';
import './home-landing.css';

type Tr=(en:string,de:string)=>string;
const detect=()=>{const ua=navigator.userAgent;return /Android/i.test(ua)?'android':/Mac/i.test(ua)?'mac':/Linux/i.test(ua)?'linux':'windows';};
const DOWNLOADS={windows:'/downloads/MALVO-Chat-Setup.exe',mac:'/downloads/MALVO-Chat-macOS-arm64.zip',linux:'/downloads/MALVO-Chat-Linux-x64.AppImage.zip',android:'/downloads/MALVO-Chat-Android.apk'};

const Face=({c,l,speaking=false,size=36}:{c:string;l:string;speaking?:boolean;size?:number})=><i className={'hl-face'+(speaking?' speaking':'')} style={{background:c,width:size,height:size,fontSize:size*0.4}}>{l}</i>;

// Faint character field behind the hero, denser towards the bottom; seeded so it never jumps between renders.
function useNoise(){
 return useMemo(()=>{let s=7;const rnd=()=>(s=(s*16807)%2147483647)/2147483647;const chars=' .:-=+*';const rows=[];
  for(let y=0;y<34;y++){let r='';for(let x=0;x<220;x++){const d=y/34;r+=rnd()<d*0.75?chars[1+Math.floor(rnd()*(chars.length-1)*d)]:' ';}rows.push(r);}return rows.join('\n');},[]);
}

// Static picture of the real app layout so visitors see what they get.
function ChatPreview({tr}:{tr:Tr}){
 return <div className="hl-window" aria-hidden="true">
  <div className="hl-app">
   <nav className="hl-rail"><img src="/icon.png" alt=""/><hr/><i className="hl-server active">ML</i><i className="hl-server" style={{background:'#3b2a6b'}}>GG</i><i className="hl-server" style={{background:'#14532d'}}>DEV</i><i className="hl-server add"><Plus size={18}/></i></nav>
   <aside className="hl-side">
    <header>MALVO Lounge</header>
    <div className="hl-search"><Search size={13}/>{tr('Search','Suchen')}</div>
    <small>{tr('TEXT CHANNELS','TEXTKANÄLE')}</small>
    <span><Hash size={15}/>{tr('welcome','willkommen')}</span>
    <span className="active"><Hash size={15}/>{tr('general','allgemein')}</span>
    <span><Hash size={15}/>clips<em>3</em></span>
    <small>{tr('VOICE CHANNELS','SPRACHKANÄLE')}</small>
    <span><Volume2 size={15}/>Lounge</span>
    <div className="hl-voice-user"><Face c="#ef5252" l="L" size={20} speaking/>Lena</div>
    <div className="hl-voice-user"><Face c="#8b5cf6" l="E" size={20}/>Elias<MonitorUp size={12}/></div>
    <footer><Face c="#f59e0b" l="D" size={30}/><span><b>{tr('You','Du')}</b><small>Online</small></span><Mic size={15}/><Headphones size={15}/><Settings size={15}/></footer>
   </aside>
   <main className="hl-main">
    <header><Hash size={17}/><b>{tr('general','allgemein')}</b><div><Bell size={16}/><Pin size={16}/><Users size={16}/></div></header>
    <div className="hl-msgs">
     <div className="hl-msg"><Face c="#ef5252" l="L"/><div><p><b style={{color:'#ef5252'}}>Lena</b><time>20:14</time></p><p>{tr('Who is up for a round later? Lounge is open 🎮','Wer hat später Bock auf eine Runde? Lounge ist offen 🎮')}</p></div></div>
     <div className="hl-msg"><Face c="#3b82f6" l="J"/><div><p><b>Jonas</b><time>20:15</time></p><p>{tr('I am in. Here is yesterday\'s clip:','Bin dabei. Hier der Clip von gestern:')}</p><div className="hl-clip"><span>▶</span><small>clip_ranked.mp4 · 48 MB</small></div></div></div>
     <div className="hl-msg"><Face c="#10b981" l="M"/><div><p><b>Mia</b><time>20:16</time></p><p>{tr('That ending 😂','Das Ende 😂')}</p><div className="hl-reactions"><em>🔥 4</em><em>😂 3</em></div></div></div>
    </div>
    <div className="hl-compose"><Plus size={18}/><span>{tr('Message #general','Nachricht an #allgemein')}</span><Gift size={17}/><Smile size={17}/></div>
   </main>
   <aside className="hl-members">
    <small>ADMIN — 1</small>
    <span><Face c="#ef5252" l="L" size={30}/><b style={{color:'#ef5252'}}>Lena</b></span>
    <small>{tr('MEMBERS — 3','MITGLIEDER — 3')}</small>
    <span><Face c="#3b82f6" l="J" size={30}/><b>Jonas</b></span>
    <span><Face c="#10b981" l="M" size={30}/><b>Mia</b></span>
    <span><Face c="#8b5cf6" l="E" size={30}/><b>Elias</b></span>
   </aside>
  </div>
 </div>;
}

function VoicePreview({tr}:{tr:Tr}){
 return <div className="hl-voice" aria-hidden="true">
  <header><Volume2 size={15}/><b>Lounge</b><small>4 {tr('connected','verbunden')}</small></header>
  <div className="hl-voice-grid">
   <div className="hl-tile screen"><span className="hl-screen-art"/><small><MonitorUp size={12}/>Elias · {tr('screen','Bildschirm')}</small></div>
   <div className="hl-tile speaking"><Face c="#ef5252" l="L" size={54}/><small>Lena</small></div>
   <div className="hl-tile"><Face c="#3b82f6" l="J" size={54}/><small>Jonas</small></div>
   <div className="hl-tile"><Face c="#10b981" l="M" size={54}/><small><MicOff size={12}/>Mia</small></div>
  </div>
  <footer><i><Mic size={17}/></i><i><Video size={17}/></i><i className="on"><MonitorUp size={17}/></i><i className="leave"><PhoneOff size={17}/></i></footer>
 </div>;
}

function BotPreview({tr}:{tr:Tr}){
 return <div className="hl-botbox" aria-hidden="true">
  <div className="hl-cmds">
   <p><code>/remind</code><span>{tr('Set a reminder','Erinnerung setzen')}</span><em>MALVO Utility</em></p>
   <p><code>/clear</code><span>{tr('Delete recent messages','Letzte Nachrichten löschen')}</span><em>MALVO Moderator</em></p>
   <p><code>/roll</code><span>{tr('Roll a dice','Würfeln')}</span><em>MALVO Fun</em></p>
  </div>
  <div className="hl-msg"><Face c="#10b981" l="M"/><div>
   <p><b>Mia</b><time>20:17</time></p>
   <div className="hl-poll"><b>{tr('Which game tonight?','Welches Spiel heute Abend?')}</b>
    <div><span style={{width:'64%'}}/><em>Valorant</em><small>64%</small></div>
    <div><span style={{width:'36%'}}/><em>Minecraft</em><small>36%</small></div>
   </div>
  </div></div>
 </div>;
}

export function HomeLanding({tr,onStart,onRegister,signedIn=false}:{tr:Tr;onStart:()=>void;onRegister:()=>void;signedIn?:boolean}){
 const os=detect(),noise=useNoise();
 const downloadLabel=os==='android'?'Android APK · Early Beta':tr('Download for ','Download für ')+({windows:'Windows',mac:'macOS',linux:'Linux'}[os]);
 const go=(id:string)=>(e:React.MouseEvent)=>{e.preventDefault();document.getElementById(id)?.scrollIntoView({behavior:'smooth',block:'start'});};
 const points=[
  [tr('Files up to 5 GB','Dateien bis 5 GB'),tr('Clips, recordings and projects go straight into the chat.','Clips, Aufnahmen und Projekte landen direkt im Chat.')],
  [tr('Roles and permissions','Rollen und Rechte'),tr('Private channels and voice rooms only selected roles can join.','Private Kanäle und Sprachräume nur für ausgewählte Rollen.')],
  [tr('Groups with up to 10 friends','Gruppen mit bis zu 10 Freunden'),tr('Group chats with calls, outside of any server.','Gruppenchats mit Anrufen, ganz ohne Server.')],
  [tr('Official bots','Offizielle Bots'),tr('Moderation, welcome messages, reminders and games, ready to add.','Moderation, Begrüßung, Erinnerungen und Spiele, sofort einsetzbar.')],
  [tr('Desktop app','Desktop-App'),tr('Windows with automatic updates, macOS and Linux in beta.','Windows mit automatischen Updates, macOS und Linux als Beta.')],
  [tr('Your look','Dein Look'),tr('Themes, banners and profile colours for you and your server.','Themes, Banner und Profilfarben für dich und deinen Server.')],
 ];
 return <div className="hl">
  <nav className="hl-nav">
   <a href="/" className="hl-logo" onClick={go('hl-top')}><img src="/icon.png" alt=""/>MALVO</a>
   <div className="hl-links"><a href="#hl-product" onClick={go('hl-product')}>{tr('Product','Produkt')}</a><a href="#hl-inside" onClick={go('hl-inside')}>{tr('Features','Funktionen')}</a><a href="#hl-get" onClick={go('hl-get')}>Download</a></div>
   <button type="button" className="hl-btn light small" onClick={onStart}><LogIn size={14}/>{signedIn?tr('Open chat','Zum Chat'):tr('Log in','Anmelden')}</button>
  </nav>

  <header className="hl-hero" id="hl-top">
   <pre className="hl-noise" aria-hidden="true">{noise}</pre>
   <div className="hl-dots" aria-hidden="true" style={{WebkitMaskImage:'url(/icon.png)',maskImage:'url(/icon.png)'}}/>
   <div className="hl-hero-text">
    <h1>{tr('Your community','Deine Community')}<br/><span>{tr('deserves more.','verdient mehr.')}</span></h1>
    <b>{tr('Text, voice and screen sharing in one app.','Text, Sprache und Bildschirm in einer App.')}</b>
    <p>{tr('MALVO brings friends, servers and large files together: in your browser, on Windows, macOS and Linux, and now as an Android Early Beta.','MALVO bringt Freunde, Server und große Dateien zusammen: im Browser, auf Windows, macOS und Linux und jetzt als Android Early Beta.')}</p>
    <div className="hl-cta">
     <button type="button" className="hl-btn red" onClick={onStart}>{tr('Open in browser','Im Browser starten')}</button>
     <a className="hl-btn light" href={DOWNLOADS[os]} download>{downloadLabel}</a>
    </div>
    {os!=='android'&&<a className="hl-android-link" href={DOWNLOADS.android} download><Smartphone size={15} aria-hidden="true"/>Android APK · Early Beta</a>}
   </div>
  </header>

  <div className="hl-frame">
   <section className="hl-intro" id="hl-product">
    <h2>{tr('Chat, voice and bots in one place','Chat, Sprache und Bots an einem Ort')} <MessageSquare size={20}/></h2>
    <p>{tr('Everything a community needs, without switching between apps.','Alles, was eine Community braucht, ohne zwischen Apps zu wechseln.')}</p>
   </section>

   <section className="hl-row">
    <div className="hl-copy">
     <h3><Hash size={17}/>{tr('Servers & chat','Server & Chat')}</h3>
     <b>{tr('Channels, categories, replies and reactions.','Kanäle, Kategorien, Antworten und Reaktionen.')}</b>
     <p>{tr('Organise your server with categories and roles, share clips up to 5 GB and keep track with mentions and unread markers.','Ordne deinen Server mit Kategorien und Rollen, teile Clips bis 5 GB und behalte den Überblick mit Erwähnungen und Ungelesen-Markierungen.')}</p>
     <small className="hl-tag">Browser · Desktop</small>
    </div>
    <div className="hl-shot"><ChatPreview tr={tr}/></div>
   </section>

   <section className="hl-row flip">
    <div className="hl-shot pad"><VoicePreview tr={tr}/></div>
    <div className="hl-copy">
     <h3><Volume2 size={17}/>{tr('Voice & screen','Sprache & Bildschirm')}</h3>
     <b>{tr('One click into the voice channel.','Ein Klick in den Sprachkanal.')}</b>
     <p>{tr('Talk with your friends, share a window or your whole screen and see at a glance who is talking. Group calls work in group chats too.','Rede mit deinen Freunden, teile ein Fenster oder den ganzen Bildschirm und sieh sofort, wer gerade spricht. Auch in Gruppenchats als Gruppenanruf.')}</p>
     <button type="button" className="hl-btn red small" onClick={onStart}>{tr('Try it','Ausprobieren')}</button>
    </div>
   </section>

   <section className="hl-row">
    <div className="hl-copy">
     <h3><Bot size={17}/>{tr('Bots & API','Bots & API')}</h3>
     <b>{tr('Official bots, ready to go.','Offizielle Bots, sofort startklar.')}</b>
     <p>{tr('Add moderation, welcome messages and reminders with one click, or build your own bot with slash commands, buttons and the developer API.','Füge Moderation, Begrüßungen und Erinnerungen mit einem Klick hinzu oder baue deinen eigenen Bot mit Slash-Befehlen, Buttons und der Entwickler-API.')}</p>
     <small className="hl-tag">{tr('Developer portal','Entwicklerportal')}</small>
    </div>
    <div className="hl-shot pad"><BotPreview tr={tr}/></div>
   </section>

   <section className="hl-intro" id="hl-inside"><h2>{tr('What is inside','Was drin ist')} <Settings size={20}/></h2></section>
   <section className="hl-inside">
    <div className="hl-statement"><p>{tr('We build MALVO for people who spend their evenings in voice channels and run their own communities.','Wir bauen MALVO für Leute, die ihre Abende im Sprachkanal verbringen und eigene Communities aufbauen.')}</p></div>
    <ol>{points.map(([t,d],i)=><li key={t}><b><span>{String(i+1).padStart(2,'0')}</span>{t}</b><p>{d}</p></li>)}</ol>
   </section>

   <section className="hl-get" id="hl-get">
    <div><h2>{tr('Get started','Loslegen')}</h2><p>{tr('Create an account in seconds and invite your friends.','In Sekunden ein Konto erstellen und Freunde einladen.')}</p></div>
    <div className="hl-cta"><a className="hl-btn light" href={DOWNLOADS[os]} download><Download size={14}/>{downloadLabel}</a><button type="button" className="hl-btn red" onClick={onRegister}>{signedIn?tr('Open chat','Zum Chat'):tr('Create account','Konto erstellen')}</button></div>
    <nav className="hl-platforms" aria-label={tr('All downloads','Alle Downloads')}><a href={DOWNLOADS.windows} download>Windows</a><a href={DOWNLOADS.mac} download>macOS</a><a href={DOWNLOADS.linux} download>Linux</a><a href={DOWNLOADS.android} download><Smartphone size={15} aria-hidden="true"/>Android APK <span>Early Beta</span></a></nav>
    <p className="hl-beta-note">{tr('Android 8 or later · Install the APK manually. Early Beta: some features are still being tested.','Ab Android 8 · APK manuell installieren. Early Beta: Einige Funktionen werden noch erprobt.')}</p>
   </section>
  </div>

  <nav className="hl-legal" aria-label={tr('Legal','Rechtliches')}>
   <span>{tr('Legal','Rechtliches')}</span>
   <a className="hl-btn light small" href={tr('/tos','/tos?lang=de')}>{tr('Terms of Service','Nutzungsbedingungen')}</a>
   <a className="hl-btn ghost small" href={tr('/privacy','/privacy?lang=de')}>{tr('Privacy','Datenschutz')}</a>
   <a className="hl-btn ghost small" href={tr('/legal','/legal?lang=de')}>{tr('Legal notice','Impressum')}</a>
  </nav>
  <footer className="hl-term">
   <p><span>root@malvo:~$</span> info</p><p className="out">{tr('Chat, voice and screen sharing for communities.','Chat, Sprache und Bildschirm für Communities.')}</p>
   <p><span>root@malvo:~$</span> ls ./downloads</p><p className="out"><a href={DOWNLOADS.windows} download>windows</a>  <a href={DOWNLOADS.mac} download>macos</a>  <a href={DOWNLOADS.linux} download>linux</a>  <a href={DOWNLOADS.android} download>android-apk</a></p>
   <p><span>root@malvo:~$</span> cat ./legal.txt</p><p className="out"><a href={tr('/tos','/tos?lang=de')}>{tr('terms','agb')}</a>  <a href={tr('/legal','/legal?lang=de')}>{tr('legal-notice','impressum')}</a>  <a href={tr('/privacy','/privacy?lang=de')}>{tr('privacy','datenschutz')}</a></p>
   <p><span>root@malvo:~$</span> <i className="hl-caret"/></p>
   <small>© {new Date().getFullYear()} MALVO Chat</small>
  </footer>
 </div>;
}
